import React, { FC, useEffect, useState } from "react"
import { Layout, Row, Select, Tabs } from "antd"
import { HeaderText } from "../common/HeaderText"
import { fetchPastTournaments, fetchTournamentMatches } from "../../services/PubgService"
import { Tournament } from "../../models/Tournament"
import { LeaderboardStats } from "../LeaderboardStats"
import { Awards } from "../Awards"
import { Match } from "../../models/Match"
import { matchTotal } from "../../services/StatAggregatorService"
import { useParams } from "react-router-dom"
import { BonusComponent } from "../bonus/BonusComponent"

const { Header, Content } = Layout
const { Option } = Select;
const { TabPane } = Tabs;

export const PastTournamentComponent: FC = () => {
    const [pastTournaments, setPastTournaments] = useState<Array<Tournament>>([])
    const [optionList, setOptionList] = useState<Array<any>>([])
    const [selectedTournament, setSelectedTournament] = useState<Tournament>()
    const [bounties, setBounties] = useState<Array<string>>([])
    const [matches, setMatches] = useState<Array<Match>>([])
    const [totalStats, setTotalStats] = useState<Array<any>>([])
    const [bonusMatches, setBonusMatches] = useState<Array<Match>>([])
    const pathParams = useParams<{ id: string }>();

    useEffect(() => {
        loadPastTournaments()
    }, [])

    useEffect(() => {
        generateMenu()
        if (pathParams?.id !== null) {
            try {
                const tourneyId: number = +pathParams?.id
                handleSelectPastTournament(tourneyId)
            } catch (error) {
                console.error("Casual")
            }
        }
    }, [pastTournaments])

    async function loadPastTournaments() {
        const pastTournamentList = await fetchPastTournaments()
        setPastTournaments(pastTournamentList)
    }

    async function handleSelectPastTournament(value: number) {
        pastTournaments.forEach((x) => {
            if (x.tournamentid === value) {
                console.debug("Tournament Match: ", x)
                setSelectedTournament(x)
                if (x.bounties === "null") {
                    setBounties([])
                } else {
                    setBounties(x.bounties.split(","))
                }

                updateEverythingElse(x)
            }
        })
    }

    async function updateEverythingElse(tournament: Tournament) {
        const matches = await fetchTournamentMatches(tournament.tournamentid)
        const regularMatches = matches.filter((match) => { return match.type !== "Bonus" })
        const bonusMatches = matches.filter((match) => { return match.type === "Bonus" })

        setMatches(regularMatches)
        setTotalStats(matchTotal(regularMatches))
        setBonusMatches(bonusMatches)
    }

    const generateMenu = () => {
        if (pastTournaments.length === 0) {
            return (<></>)
        }

        const tournaments = pastTournaments.map((pastTournament) => {
            return (
                <Option value={pastTournament.tournamentid} key={"past-tourney-option-" + pastTournament.tournamentid}>
                    {pastTournament.name} - {pastTournament.date}
                </Option>
            )
        })

        setOptionList(tournaments)
    }

    return (
        <>
            <Layout>
                <Header>
                    <HeaderText title={"Past Tournaments"} />
                </Header>
                <Content className="mainContent">
                    <Row justify="space-around">
                        <Select placeholder={"Select a past tournament"} onChange={handleSelectPastTournament} className="selectDropDown">
                            {optionList}
                        </Select>
                    </Row>
                    {selectedTournament && <Tabs>
                        <TabPane tab={"Awards"} key="past-tourney-awards">
                            <Awards bounties={bounties} pointSystem={selectedTournament?.placement} matches={matches} stats={totalStats} hideHeader={true} />
                        </TabPane>
                        <TabPane tab={"Leaderboards"} key="past-tourney-leaderboards">
                            <LeaderboardStats hideHeader={true} pointSystem={selectedTournament?.placement} matches={matches} />
                        </TabPane>
                        <TabPane tab={"Bonus"} key="past-tourney-bonus">
                            <BonusComponent bonusMatches={bonusMatches} />
                        </TabPane>
                    </Tabs>}
                </Content>
            </Layout>
        </>
    )
}